import { PasswordValidatorRef } from "components/PasswordRequirements/interfaces";
import { PasswordStrengthIndicator } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  password: string;
  className?: string;
  textColor?: string;
  textVariant?: string;
}

const PasswordRequirements = React.forwardRef<PasswordValidatorRef, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const {
      password,
      className = "",
      textColor = "primary",
      textVariant = "body9",
    } = props;

    return (
      <PasswordStrengthIndicator
        ref={ref}
        className={className}
        textClassName="password-requirements-text"
        textColor={textColor}
        textVariant={textVariant}
        password={password}
        translations={{
          requirements: t("8140") /* A sua palavra-passe deve: */,
          minChars: t("8141") /* Ter pelo menos 10 carateres */,
          subRequirements: t("8142") /* Conter 3 destes elementos: */,
          uppercaseChars: t("8150") /* Letras maiúsculas; */,
          lowercaseChars: t("8151") /* Letras minúsculas; */,
          numbers: t("8152") /* Números; */,
          specialChars: t("8153") /* Carateres especiais */,
          strongLevel: t("8143") /* Atingir o nível forte */,
          levelIndicator: t("8144") /* Indicador de nível */,
          level: t("8146") /* Nível */,
          weak: t("8148") /* Fraco */,
          moderate: t("8149") /* Moderado */,
          strong: t("8147") /* Forte */,
        }}
      />
    );
  }
);

export default PasswordRequirements;
